import React, { useState } from 'react';
import { verificationCodeRequest } from '../network/post_authsand';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { signUp } from '../network/signup';
import { MdArrowBackIos } from "react-icons/md";
import { findId } from '../network/post_findId';
import { resetPw } from '../network/post_resetpw';

function Find_password() {
  const [gender, setGender] = useState('M'); // 'M' for 남성, 'W' for 여성
    const [id, setId] = useState(''); 
        const [pw, setPw] = useState(''); 
            const [pwchk, setPwchk] = useState(''); 
  const [isAgreed, setIsAgreed] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
    const [authNumber, setAuthNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false); // ⭐️ 로딩 상태 추가
    const [isSend, setIsSend] = useState(false); // 
    //const [extraHeader, setExtraHeader] = useState('username'); // 
    const [authMessage, setAuthMessage] = useState(''); // ⭐️ 사용자 피드백 메시지 상태
    const [searchParams] = useSearchParams();

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

        const [isAuth, setIsAuth] = useState(false); //

        const [findIdResult, setFindIdResult] = useState(null); 
    // ⭐️ 비밀번호 재설정 모달 제어 상태
    const [showResetModal, setShowResetModal] = useState(false);

          const navigate = useNavigate();

  // 컴포넌트 내부에 상태 관리 로직 (onChange, validation 등)을 추가할 수 있습니다.

  const usertype = searchParams.get('id'); 
  const accessToken = searchParams.get('socialAccountToken'); 

   const goBack = () => {
    // navigate(-1)을 호출하여 이전 경로로 이동
    navigate(-1);
  };

  const handleAuthRequest = async () => {
        setAuthMessage(''); // 이전 메시지 초기화
        
        if (!phoneNumber) {
            setAuthMessage('휴대폰 번호를 입력해 주세요.');
            return;
        }

        const result = await verificationCodeRequest(
            phoneNumber,
            'find_account', // purpose (목적) 설정
            setIsLoading // 로딩 상태 제어 함수 전달
        );

        console.log(result)
        console.log(result.success)
        
        if (result.success) {
            setAuthMessage(result.message || '인증번호 발송 성공!');
            setIsSend(true)
            // 성공 시, 인증번호 입력 필드를 보여주는 로직 추가
        } else {
            // 실패 메시지 표시

            const failMessage = result.message || '인증 요청에 실패했습니다.';
            setModalMessage(failMessage);
            
            // 2. 팝업 표시 상태를 true로 설정
            setShowErrorModal(true);
            
            setIsLoading(false)
            
        }
    };


    const handleFindIdAndReset = async () => {
        // 1. 입력 필드 유효성 검사 (필요시 추가)
        if (!phoneNumber || !authNumber) {
            setModalMessage('휴대폰 번호와 인증번호를 모두 입력해주세요.');
            setShowErrorModal(true);
            return;
        }

        try {
            const result = await findId(phoneNumber, authNumber);
            
            if (result.message && result.message.account_type === 'username') {
                // ⭐️ 성공: 응답 저장 후 비밀번호 재설정 팝업 띄우기
                setFindIdResult(result.message);
                setShowResetModal(true);
            } else {
                // ⭐️ 실패: 찾은 계정 타입이 username이 아닐 경우 (API 로직에 따라)
                setModalMessage('일반 아이디 정보를 찾을 수 없습니다.');
                setShowErrorModal(true);
            }
        } catch (error) {
            // ⭐️ API 호출 자체 실패 처리
            setModalMessage(error.message || '계정 정보 찾기에 실패했습니다.');
            setShowErrorModal(true);
        }
    };

  return (
    <div style={styles.mobileContainer}>

      <MdArrowBackIos size="24" onClick={goBack} style={{marginTop:'1vw', marginRight:'25vw'}} />

      {showErrorModal && (
                <ErrorDisplayModal
                    message={modalMessage}
                    onClose={() => setShowErrorModal(false)}
                />
            )}

            {showResetModal && findIdResult && (
            <ResetPasswordModal
                username={findIdResult.username}
                auth={authNumber}
                phone={phoneNumber}
                onClose={() => setShowResetModal(false)}
            />
        )}
      
      {/* 1. 헤더 영역 */}
      <div style={styles.header}>
        <h1 style={styles.title}>계정정보 찾기</h1>
        <p style={styles.subtitle}>아이디/비밀번호를 찾기 위한 문자인증을 진행해주세요</p>
      </div>

      {/* 3. 필수 정보 입력 섹션 */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>필수정보입력</h3>
        
        {/* 휴대폰 번호 및 인증번호 버튼 그룹 */}
        <div style={styles.phoneGroup}>
          <input style={styles.phoneInput} type="tel" placeholder="휴대폰 번호를 입력해주세요" value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        disabled={isLoading} />
          <button 
                        onClick={handleAuthRequest} 
                        style={styles.authButton}
                        disabled={isLoading || phoneNumber.length < 10} // 유효성 검사 추가
                    >
                        {isLoading ? '전송 중...' : '인증번호 받기'} 
                    </button>
        </div>

        {isSend ?
        <div style={styles.phoneGroup}>
          <input style={styles.phoneInput} type="tel" placeholder="인증번호를 입력해주세요" value={authNumber}
                        onChange={(e) => setAuthNumber(e.target.value)}
                        />
        </div>:
        <div></div>
        }
      

  
      </div>


      {/* 5. 다음 버튼 */}
      <button 
        style={styles.nextButton}

        onClick={handleFindIdAndReset}>
        다음
      </button>

    </div>
  );
}

function ErrorDisplayModal({ message, onClose }) {
    return (
        <div style={errorModalStyles.backdrop}>
            <div style={errorModalStyles.content}>
                <h3 style={errorModalStyles.title}>인증 실패</h3>
                <p style={errorModalStyles.message}>{message}</p>
                <button onClick={onClose} style={errorModalStyles.confirmButton}>
                    확인
                </button>
            </div>
        </div>
    );
}

function ResetPasswordModal({ username,auth,phone, onClose }) {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const navigate = useNavigate();
    
    // ⭐️ 비밀번호 재설정 실행 로직
    const handlePasswordReset = async () => {
        if (newPassword.length < 8 || newPassword !== confirmPassword) {
            alert('비밀번호가 8자 이상인지 확인하고, 비밀번호 확인이 일치하는지 확인해주세요.');
            return;
        }
        
        setIsProcessing(true);
        try {
            // ⭐️ 재설정 API 호출 (API 스펙에 따라 인자 조정 필요)
            const result = await resetPw(phone,auth, newPassword);
            if(result){
            alert(`아이디 ${username}의 비밀번호를 성공적으로 재설정했습니다!`);
            navigate('/');
            //onClose(); // 성공 시 모달 닫기
            }
        } catch (error) {
            alert('비밀번호 재설정에 실패했습니다.');
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div style={errorModalStyles.backdrop}>
            <div style={resetModalStyles.content}>
                <h3 style={resetModalStyles.title}>비밀번호 재설정</h3>
                <p style={resetModalStyles.foundIdText}>
                    당신의 아이디는 **{username}** 입니다
                </p>

                {/* 새 비밀번호 입력 폼 */}
                <input 
                    type="password"
                    placeholder="새 비밀번호를 입력해주세요"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    style={resetModalStyles.inputField}
                    disabled={isProcessing}
                />
                <input 
                    type="password"
                    placeholder="새 비밀번호를 확인해주세요"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={resetModalStyles.inputField}
                    disabled={isProcessing}
                />
                
                <div style={resetModalStyles.buttonGroup}>
                    <button onClick={onClose} style={resetModalStyles.cancelButton} disabled={isProcessing}>
                        취소
                    </button>
                    <button 
                        onClick={handlePasswordReset} 
                        style={resetModalStyles.confirmButton}
                        disabled={isProcessing || newPassword !== confirmPassword || newPassword.length < 8}
                    >
                        재설정
                    </button>
                </div>
            </div>
        </div>
    );
}

const resetModalStyles = {
    // Backdrop은 errorModalStyles의 것을 재사용
    content: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '20px',
        width: '90%',
        maxWidth: '350px',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    title: {
        fontSize: '20px',
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    foundIdText: {
        fontSize: '15px',
        marginBottom: '20px',
        padding: '5px 0',
        textAlign: 'center',
    },
    inputField: {
        width: '100%',
        padding: '10px 15px',
        border: '1px solid #ddd',
        borderRadius: '5px',
        marginBottom: '10px',
        boxSizing: 'border-box',
    },
    buttonGroup: {
        display: 'flex',
        marginTop: '20px',
        gap: '10px',
    },
    cancelButton: {
        flex: 1,
        padding: '10px',
        backgroundColor: '#eee',
        border: 'none',
        borderRadius: '5px',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    confirmButton: {
        flex: 1,
        padding: '10px',
        backgroundColor: '#ff4d4f', // 빨간색
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        fontWeight: 'bold',
        cursor: 'pointer',
    }
};

// ----------------------------------------------------
// 스타일 정의 (모바일 최적화)
// ----------------------------------------------------


const errorModalStyles = {
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    content: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '30px',
        width: '80%',
        maxWidth: '300px',
        textAlign: 'center',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '15px',
        color: '#ff4d4f', // 에러 강조색
    },
    message: {
        fontSize: '15px',
        marginBottom: '20px',
        color: '#333',
    },
    confirmButton: {
        width: '100%',
        padding: '10px',
        backgroundColor: '#ff4d4f',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        fontSize: '16px',
        cursor: 'pointer',
    }
};

const styles = {
  authFeedback: {
        fontSize: '14px',
        color: 'red',
        marginTop: '-10px',
        marginBottom: '10px',
    },

  mobileContainer: {
    maxWidth: '420px',
    margin: '0 auto',
    padding: '0 30px', // 좌우 패딩
    backgroundColor: 'white',
    minHeight: '100vh',
  },
  header: {
    marginBottom: '30px',
    textAlign: 'left',
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    margin: '0 0 5px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#666',
    margin: 0,
  },
  
  // 섹션 스타일
  section: {
    marginBottom: '20px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '15px',
  },
  
  // 입력 필드 스타일
  inputField: {
    width: '100%',
    padding: '12px 15px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    marginBottom: '10px',
    fontSize: '16px',
    boxSizing: 'border-box', // padding이 width에 포함되도록 설정
  },
  
  // 휴대폰 인증 그룹
  phoneGroup: {
    display: 'flex',
    gap: '10px',
    marginBottom: '15px',
  },
  phoneInput: {
    
    flexGrow: 1,
    marginBottom: 0, // phoneGroup 내에서 마진 제거
  },
  authButton: {
    flexShrink: 0, // 버튼 크기 고정
    padding: '12px 15px',
    backgroundColor: '#9e9e9eff', // 이미지의 회색 버튼
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },

  // 성별 버튼 그룹
  genderGroup: {
    display: 'flex',
    gap: '10px',
    marginBottom: '15px',
  },
  genderButtonActive: {
    flex: 1,
    padding: '15px',
    backgroundColor: '#ff4d4f', // 활성: 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  genderButtonInactive: {
    flex: 1,
    padding: '15px',
    backgroundColor: '#9e9e9eff', // 비활성: 회색
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  
  // 약관 동의 섹션
  agreementSection: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '30px',
  },
  checkbox: {
    flexShrink: 0,
    width: '20px',
    height: '20px',
    marginRight: '10px',
    marginTop: '2px',
    cursor: 'pointer',
  },
  agreementText: {
    fontSize: '14px',
    color: '#333',
    textAlign: 'left',
  },
  redText: {
    color: '#ff4d4f', // 빨간색 강조
    fontWeight: 'bold',
  },
  
  // 다음 버튼
  nextButton: {
    width: '100%',
    padding: '15px 0',
    backgroundColor: '#9e9e9eff', // 비활성 시 회색
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    // ⭐️ 활성화 시 색상 변화는 CSS나 조건부 스타일로 처리해야 합니다.
    // disabled={!isAgreed} 속성이 비활성 시 색상을 유지하도록 했습니다.
  },
};

export default Find_password;